import React from 'react'

function TenderTextAmper() {
    return (
        <embed src="\pdfs\EAT1.5.1.1_VA-ZD_Circular_displacement_outlet_with_adjustabledamper_040.2018_neu.pdf" width="100%" height="2100px" />
    )
}

export default TenderTextAmper